import { Application } from 'hooks/webapi/useApplication';
import {
  Client,
  ProductNumberKind,
  ProductNumberKindAvailables,
} from 'hooks/webapi/useClient';
import { LatestLoan } from 'hooks/webapi/useLatestLoan';
import { LOGIN, ONLINE_LOGIN } from 'Router/routes';
import {
  PRODUCT_NUMBER_ONLINE,
  PRODUCT_NUMBER_PARAM,
  PRODUCT_NUMBER_SPL,
} from 'utils/constants';

// Returns the numeric product ID matching the kind stored in sessionStorage at login
export function getClientProductNumber(
  availableProducts?: ProductNumberKind[],
): string | undefined {
  const clientProductNumberAccordingLogin =
    sessionStorage.getItem(PRODUCT_NUMBER_PARAM);

  const productNumberFromBE =
    availableProducts &&
    availableProducts.find(
      (data) => data.kind === clientProductNumberAccordingLogin,
    );

  return productNumberFromBE?.number;
}

// Returns the numeric product ID for a given kind from the client's available products
export const getProductNumber = (
  productAvailables: ProductNumberKindAvailables | undefined,
  productKind: string | null | undefined,
) => {
  const productData = productAvailables?.find(
    (data) => data.kind === productKind,
  );
  return productData?.number;
};

export const getProductKind = (
  productAvailables: ProductNumberKindAvailables | undefined,
  productKind: string | null | undefined,
) => {
  return productAvailables?.find((data) => data.kind === productKind);
};

// Checks whether a given product kind exists in the client's available products
export const isProductKindAvailable = (
  productAvailables: ProductNumberKindAvailables | undefined,
  productNumberkind: string | null,
) => Boolean(getProductNumber(productAvailables, productNumberkind));

export const isProductKind = (
  data: Application | LatestLoan | null | undefined,
  productNumberKind: string,
) => Boolean(data?.productInfo?.kind === productNumberKind);

// DEFAULT PRODUCT NUMBER ACCORDING TO LOGIN ROUTE
export const initializeProductNumberLoginRoute = () => {
  if (
    window.location.pathname === LOGIN ||
    window.location.pathname === ONLINE_LOGIN
  ) {
    const clientProductNameLogin =
      window.location.pathname === LOGIN
        ? PRODUCT_NUMBER_SPL
        : PRODUCT_NUMBER_ONLINE;
    sessionStorage.setItem(PRODUCT_NUMBER_PARAM, clientProductNameLogin);
  }
};

export const verifyProductNumberLoginRoute = (
  client: Client | null | undefined,
) => {
  if (!client) return;

  const clientProductNumberAccordingLogin =
    sessionStorage.getItem(PRODUCT_NUMBER_PARAM);

  const productNumberAvailable = isProductKindAvailable(
    client?.availableProductsInfo,
    clientProductNumberAccordingLogin,
  );

  // Client used the wrong login route
  if (!productNumberAvailable) {
    const defaultProductNumberAvailable =
      client?.availableProductsInfo?.[0]?.kind;
    sessionStorage.setItem(PRODUCT_NUMBER_PARAM, defaultProductNumberAvailable);
  }
};
